import { camelCase } from "change-case";

export function decodeObjectValues(obj: any) {
  const decodedObj: any = {};
  Object.keys(obj).forEach((key) => {
    const value = obj[key];
    if (typeof value === "string") {
      decodedObj[key] = decodeURIComponent(value);
    } else {
    }
  });
  return decodedObj;
}

export function transformKeysToCamelCase(obj: any): any {
  if (Array.isArray(obj)) {
    return obj.map(transformKeysToCamelCase);
  } else if (obj && typeof obj === "object") {
    const newObj: any = {};
    Object.keys(obj).forEach((key) => {
      const camelCasedKey = camelCase(key);
      const value = obj[key];
      newObj[camelCasedKey] = transformKeysToCamelCase(value);
    });
    return newObj;
  }
  return obj;
}
